import { AlertColor } from '@mui/material';
import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react';

interface alertContextProps {
  alert: {
    type: AlertColor;
    message: string;
    open: boolean;
  };
  setAlert: Dispatch<
    SetStateAction<{
      type: AlertColor;
      message: string;
      open: boolean;
    }>
  >;
  handleCloseAlert: () => void;
}

const alertContext = createContext<alertContextProps | undefined>(undefined);

export const AlertProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [alert, setAlert] = useState<alertContextProps['alert']>({
    type: 'success',
    message: '',
    open: false,
  });

  function handleCloseAlert() {
    setAlert({
      type: 'success',
      message: '',
      open: false,
    });
  }

  return (
    <alertContext.Provider value={{ alert, setAlert, handleCloseAlert }}>
      {children}
    </alertContext.Provider>
  );
};

export const useAlert = () => {
  const context = useContext(alertContext);
  if (!context) {
    throw new Error('useAlert must be used within a AlertProvider');
  }
  return context;
};
